/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ListIssuesByViewer_viewer = {
    readonly id: string;
    readonly issuesByViewer: {
        readonly pageInfo: {
            readonly endCursor: string | null;
            readonly hasNextPage: boolean;
        };
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly description: string;
                readonly frame: {
                    readonly id: string;
                } | null;
                readonly " $fragmentRefs": FragmentRefs<"LabelingIssueListItem_issue">;
            } | null;
        } | null>;
    };
    readonly " $refType": "ListIssuesByViewer_viewer";
};
export type ListIssuesByViewer_viewer$data = ListIssuesByViewer_viewer;
export type ListIssuesByViewer_viewer$key = {
    readonly " $data"?: ListIssuesByViewer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ListIssuesByViewer_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ListIssuesByViewer_viewer",
  "type": "Viewer",
  "metadata": {
    "connection": [
      {
        "count": "countIssuesByViewer",
        "cursor": null,
        "direction": "forward",
        "path": [
          "issuesByViewer"
        ]
      }
    ]
  },
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "countIssuesByViewer",
      "type": "Int",
      "defaultValue": 15
    },
    {
      "kind": "LocalArgument",
      "name": "onlyByViewer",
      "type": "Boolean",
      "defaultValue": true
    }
  ],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": "issuesByViewer",
      "name": "__ListIssuesByViewer_issuesByViewer_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "LabelingIssueConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "LabelingIssueEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "LabelingIssue",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "frame",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Frame",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "LabelingIssueListItem_issue",
                  "args": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '829f674d0cee1a5d41def1843376ed9d';
export default node;
